// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDhh_vboh9akh-gLOxgoBtO6ke97o802Ag",
  authDomain: "ubunifu-college.firebaseapp.com",
  databaseURL: "https://ubunifu-college.firebaseio.com",
  projectId: "ubunifu-college",
  storageBucket: "ubunifu-college.appspot.com",
  messagingSenderId: "772246694093",
  appId: "1:772246694093:web:7bc6c696889dfa99e72184",
  measurementId: "G-3T53TP9ZGZ"
}; 

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore();
const storage = getStorage(app);

export {app};
export {firebaseConfig};
export {analytics}
export {db}
export {storage}